import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = () => (
  <Box height={'100%'} width={'100%'} display={'flex'}>
    <CircularProgress sx={{ margin: 'auto' }} />
  </Box>
);

export default LoadingSpinner;
